import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const AbsenceRequestsWidget: WidgetRegistryEntry = {
  name: "AbsenceRequests",
  component: () => import("./absence-requests-widget.component").then((m) => m.AbsenceRequestsWidgetComponent),
  configuration: () => import("./configuration").then((m) => m.AbsenceRequestsWidgetConfiguration)
};
